export const QUERY_NOTIFICATIONS_NOTIFICATIONS =
  "QUERY_NOTIFICATIONS_NOTIFICATIONS";
export const QUERY_NOTIFICATIONS_NOTIFICATION =
  "QUERY_NOTIFICATIONS_NOTIFICATION";
